module.exports = __webpack_public_path__ + "static/media/Illus-Location.843eb6a9.png";